import { render, staticRenderFns } from "./VideoCallUserIcon.vue?vue&type=template&id=495ef715&scoped=true&"
import script from "./VideoCallUserIcon.vue?vue&type=script&lang=ts&"
export * from "./VideoCallUserIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallUserIcon.vue?vue&type=style&index=0&id=495ef715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ef715",
  null
  
)

export default component.exports